<template>
  <div class="ad-page">
    <slot name="nav-bar">
      <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
    </slot>
    <div class="ad-page-main">
      <slot />
    </div>
  </div>
</template>

<script>
import { closeWebView } from '@/utils/ad'

export default {
  name: 'AdPage',

  props: {
    // 导航栏标题
    title: {
      type: String,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  async created() {},

  methods: {
    onClickLeft() {
      closeWebView()
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-page {
  // height: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column;
  background-color: #f7f7f7;
}

.ad-page-main {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
